// 每次只弹出一个消息框
import { Message } from 'element-ui'

let messgaeInstance = null;

const resetMessage = (options) => {
    if (messgaeInstance) {
        messgaeInstance.close()
    }
    messgaeInstance = Message(options)
}

['error', 'success', 'info', 'warning'].forEach(type => {
    resetMessage[type] = options => {
        if (typeof options == 'string') {
            options = {
                message: options,
                showClose: false,
                duration: 1500
            }
        }
        options.type = type
        return resetMessage(options)
    }
})

export const message = resetMessage


// WEBPACK FOOTER //
// ./utils/message.js